import styled, { keyframes } from "styled-components";
import qrCode from "./img/qr-code@2x.png";
import { zoomIn } from "react-animations";
const zoomInAnimation = keyframes`${zoomIn}`;
export const QRCode = styled.img.attrs({
  src: qrCode
})`
  margin-top: calc(83rem/100);
  width: calc(116rem/100);
  height: calc(116rem/100);
  border-radius: calc(3rem/100);
  animation: .8s ${zoomInAnimation} ease-in-out .4s both;
`;
